var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirEcologyBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.7917V5.20833C4 4.6558 4.21071 4.12589 4.58579 3.73519C4.96086 3.34449 5.46957 3.125 6 3.125H19.4C19.5591 3.125 19.7117 3.19085 19.8243 3.30806C19.9368 3.42527 20 3.58424 20 3.75V17.4104",
    stroke: "#29292E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.5833C10 14.5833 10.9 11.3354 13 9.375",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8002 12.9431L12.6662 12.9556C11.8525 13.0347 11.0419 12.7752 10.4113 12.2338C9.78062 11.6924 9.38121 10.9131 9.30021 10.066C9.26024 9.64783 9.30005 9.22551 9.41737 8.82338C9.53469 8.42126 9.72719 8.04727 9.9838 7.72294C10.2404 7.39862 10.5561 7.13036 10.9126 6.9336C11.2691 6.73684 11.6595 6.61546 12.0612 6.57647L15.0472 6.2848C15.1393 6.27579 15.2311 6.30515 15.3025 6.36644C15.3739 6.42773 15.4191 6.51598 15.4282 6.61188L15.6832 9.29938C15.7251 9.73611 15.6837 10.1772 15.5612 10.5971C15.4388 11.0171 15.2378 11.4076 14.9698 11.7463C14.7018 12.085 14.3722 12.3651 13.9998 12.5705C13.6274 12.7759 13.2198 12.9026 12.8002 12.9431Z",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.708H20M6 21.8747H20",
    stroke: "#29292E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.8747C5.46957 21.8747 4.96086 21.6552 4.58579 21.2645C4.21071 20.8738 4 20.3439 4 19.7913C4 19.2388 4.21071 18.7089 4.58579 18.3182C4.96086 17.9275 5.46957 17.708 6 17.708",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirEcologyBook);
export default __webpack_public_path__ + "static/media/iconoir_ecology-book.7d3267f421d7b6f29632ac3c121d20f2.svg";
export { ForwardRef as ReactComponent };